import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import {
  CATEGORY_ID,
  CHANGE_REQUEST_SUBCATEGORIES
} from '@/features/TicketCreateDialog/TicketCreateDialog.constants';
import useStyles from '@/features/TicketCreateDialog/TicketCreateDialog.styles';

const ServiceForm = () => {
  const {
    control,
    formState: { errors },
    setValue
  } = useFormContext();
  const { classes } = useStyles({ errors });

  const ticketCategory = useWatch({ control, name: 'ticket_category' });

  const isCategoryWithSubcategories =
    ticketCategory === CATEGORY_ID.CHANGE_REQUEST;
  const categorySubCategories = isCategoryWithSubcategories
    ? CHANGE_REQUEST_SUBCATEGORIES
    : [];

  //-----------------------------------------------------------------
  // business logic to conditionally set team queue select value
  useEffect(() => {
    if (ticketCategory === CATEGORY_ID.CHANGE_REQUEST) {
      setValue('ticket_subcategory', 1);
      return;
    }
    setValue('ticket_subcategory', '');
  }, [ticketCategory]);

  return (
    <>
      {isCategoryWithSubcategories && (
        <Stack className={classes.ticketCreateDialogFormElement}>
          <InputLabel htmlFor="subcategory-select">Sub-Category *</InputLabel>
          <FormControl fullWidth>
            <Controller
              control={control}
              name="ticket_subcategory"
              rules={{
                required: true
              }}
              render={({ field, formState }) => (
                <Select
                  id="subcategory-select"
                  error={!!formState.errors.ticket_subcategory}
                  {...field}
                >
                  {categorySubCategories.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </Stack>
      )}
    </>
  );
};

export default ServiceForm;
